(function () {
  var activeRequest = null;

  function findGridSection(root) {
    root = root || document;

    var directSelectors = [
      '[id^="shopify-section-"]:has(> .coll-body)',
      '[id^="shopify-section-"]:has(#main-collection-product-grid)',
      '[id^="shopify-section-"]:has(.collection-default)',
      '[id^="shopify-section-"]:has(.collection-full-width)',
      '[id^="shopify-section-"]:has(.collection-masonry)',
      '[id^="shopify-section-"]:has(.collection-right-sidebar)',
      '[id^="shopify-section-"]:has(.collection-express-order)',
      '[id^="shopify-section-"]:has(.collection-banner-adv)'
    ];

    for (var i = 0; i < directSelectors.length; i += 1) {
      try {
        var direct = root.querySelector(directSelectors[i]);
        if (direct) return direct;
      } catch (error) {
        // :has() is not available in a few older browsers; use the fallback below.
        break;
      }
    }

    var content = root.querySelector(
      '.coll-body, #main-collection-product-grid, .collection-default, .collection-full-width, .collection-masonry, .collection-right-sidebar, .collection-express-order, .collection-banner-adv, [data-collection-products]'
    );
    return content ? content.closest('[id^="shopify-section-"]') : null;
  }

  function getGridSection() {
    return findGridSection(document);
  }

  function activateScripts(container) {
    container.querySelectorAll('script:not([src])').forEach(function (oldScript) {
      var newScript = document.createElement('script');
      Array.prototype.forEach.call(oldScript.attributes, function (attribute) {
        newScript.setAttribute(attribute.name, attribute.value);
      });
      newScript.textContent = oldScript.textContent;
      oldScript.parentNode.replaceChild(newScript, oldScript);
    });
  }

  function extractCount(container) {
    var countNode = container.querySelector(
      '.coll-count, .collection-product-count, .collection-product-count__text, [data-product-count]'
    );
    if (!countNode) return '';
    var text = countNode.textContent.replace(/\s+/g, ' ').trim();
    var match = text.match(/[\d,]+/);
    return match ? match[0] : '';
  }

  function updateHeroCount(count) {
    if (!count) return;
    var meta = document.querySelector('[data-preet-collection-hero] .pch-meta span:first-child');
    if (meta) meta.textContent = count + (count === '1' ? ' bottle' : ' bottles');
  }

  function setActiveLink(rail, activeLink) {
    rail.querySelectorAll('[data-preet-palate-link]').forEach(function (link) {
      var active = link === activeLink;
      link.classList.toggle('is-active', active);
      link.classList.remove('is-loading');
      if (active) link.setAttribute('aria-current', 'page');
      else link.removeAttribute('aria-current');
    });
  }

  function setStatus(filterRoot, message) {
    var status = filterRoot && filterRoot.querySelector('[data-preet-filter-status]');
    if (status) status.textContent = message || '';
  }

  function buildStateUrl(filterRoot, targetUrl) {
    var baseUrl = filterRoot.getAttribute('data-preet-base-url') || window.location.pathname;
    var displayUrl = new URL(baseUrl, window.location.origin);
    var target = new URL(targetUrl, window.location.origin);
    var filterKey = target.pathname.replace(/^\/collections\//, '') + target.search;
    displayUrl.searchParams.set('palate', filterKey);
    displayUrl.searchParams.delete('page');
    return displayUrl.pathname + displayUrl.search;
  }

  function targetFromLocation(filterRoot) {
    var current = new URL(window.location.href);
    var palate = current.searchParams.get('palate');
    if (palate) return '/collections/' + palate.replace(/^\/+/, '');
    return filterRoot.getAttribute('data-preet-base-url') || current.pathname;
  }

  function parseCollectionDocument(html, responseUrl) {
    var parser = new DOMParser();
    var parsed = parser.parseFromString(html, 'text/html');
    var targetGrid = findGridSection(parsed);

    if (!targetGrid) {
      var title = parsed.querySelector('title');
      var titleText = title ? title.textContent : '';
      throw new Error(
        titleText.toLowerCase().indexOf('404') !== -1
          ? 'The selected collection does not exist.'
          : 'The selected collection did not return a product grid.'
      );
    }

    targetGrid.setAttribute('data-preet-filter-source', responseUrl || '');
    return targetGrid;
  }

  function replaceGrid(currentGrid, targetGrid) {
    var importedGrid = document.importNode(targetGrid, true);
    currentGrid.replaceWith(importedGrid);
    activateScripts(importedGrid);
    return importedGrid;
  }

  function fetchCollectionDocument(targetUrl, controller) {
    var requestUrl = new URL(targetUrl, window.location.origin);
    requestUrl.searchParams.delete('page');
    requestUrl.searchParams.delete('sections');
    requestUrl.searchParams.delete('section_id');

    return fetch(requestUrl.toString(), {
      signal: controller.signal,
      credentials: 'same-origin',
      cache: 'no-store',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'text/html,application/xhtml+xml'
      }
    }).then(function (response) {
      if (!response.ok) throw new Error('The collection filter could not be loaded.');
      return response.text().then(function (html) {
        return parseCollectionDocument(html, response.url || requestUrl.toString());
      });
    });
  }

  function fetchCollectionResults(targetUrl, rail, activeLink, options) {
    options = options || {};
    var filterRoot = rail.closest('[data-preet-filter-root]');
    var gridSection = getGridSection();
    if (!filterRoot || !gridSection) return Promise.reject(new Error('Collection results section was not found.'));

    if (activeRequest) activeRequest.abort();
    var controller = new AbortController();
    activeRequest = controller;

    rail.setAttribute('aria-busy', 'true');
    gridSection.classList.add('preet-collection-filtering');
    setStatus(filterRoot, 'Updating bottles…');
    if (activeLink) activeLink.classList.add('is-loading');

    return fetchCollectionDocument(targetUrl, controller).then(function (targetGrid) {
      var updatedGrid = replaceGrid(gridSection, targetGrid);
      var count = extractCount(updatedGrid);
      updateHeroCount(count);
      setActiveLink(rail, activeLink);

      if (activeLink) {
        var label = activeLink.getAttribute('data-preet-filter-label') || activeLink.textContent.trim();
        setStatus(filterRoot, 'Showing ' + label + (count ? ' · ' + count + ' bottles' : ''));
      } else {
        setStatus(filterRoot, count ? 'Showing all · ' + count + ' bottles' : 'Showing all bottles');
      }

      if (options.pushState !== false) {
        history.pushState(
          { preetPalateUrl: new URL(targetUrl, window.location.origin).toString() },
          '',
          buildStateUrl(filterRoot, targetUrl)
        );
      }

      document.dispatchEvent(new CustomEvent('preet:collection:updated', {
        detail: { url: targetUrl, section: updatedGrid }
      }));

      if (options.scroll !== false) {
        var top = updatedGrid.getBoundingClientRect().top + window.pageYOffset - 130;
        window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
      }

      return updatedGrid;
    }).catch(function (error) {
      if (error.name === 'AbortError') return null;
      setStatus(filterRoot, error.message || 'Unable to update bottles. Please try again.');
      rail.querySelectorAll('.is-loading').forEach(function (link) { link.classList.remove('is-loading'); });
      throw error;
    }).finally(function () {
      if (activeRequest !== controller) return;
      rail.removeAttribute('aria-busy');
      var currentGrid = getGridSection();
      if (currentGrid) currentGrid.classList.remove('preet-collection-filtering');
      activeRequest = null;
    });
  }

  function init(scope) {
    var root = scope || document;

    root.querySelectorAll('[data-preet-collection-hero]:not([data-pch-ready])').forEach(function (hero) {
      hero.setAttribute('data-pch-ready', 'true');
      var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var finePointer = window.matchMedia && window.matchMedia('(pointer:fine)').matches;
      if (reduced || !finePointer) return;

      var bottles = hero.querySelectorAll('.pch-bottle');
      hero.addEventListener('pointermove', function (event) {
        var rect = hero.getBoundingClientRect();
        var x = (event.clientX - rect.left) / rect.width - 0.5;
        var y = (event.clientY - rect.top) / rect.height - 0.5;
        bottles.forEach(function (bottle) {
          var depth = parseFloat(bottle.getAttribute('data-pch-depth') || '0.62');
          bottle.style.setProperty('--pch-x', (x * 22 * depth) + 'px');
          bottle.style.setProperty('--pch-y', (y * 15 * depth) + 'px');
        });
        var ghost = hero.querySelector('.pch-ghost');
        if (ghost) {
          ghost.style.setProperty('--pch-pointer-x', (x * 18) + 'px');
          ghost.style.setProperty('--pch-pointer-y', (y * 12) + 'px');
        }
      });
      hero.addEventListener('pointerleave', function () {
        bottles.forEach(function (bottle) {
          bottle.style.removeProperty('--pch-x');
          bottle.style.removeProperty('--pch-y');
        });
        var ghost = hero.querySelector('.pch-ghost');
        if (ghost) {
          ghost.style.removeProperty('--pch-pointer-x');
          ghost.style.removeProperty('--pch-pointer-y');
        }
      });
    });

    root.querySelectorAll('[data-preet-category-rail]:not([data-pch-rail-ready])').forEach(function (rail) {
      rail.setAttribute('data-pch-rail-ready', 'true');
      var pointerDown = false;
      var dragging = false;
      var suppressClick = false;
      var capturedPointerId = null;
      var startX = 0;
      var startY = 0;
      var startScroll = 0;
      var dragThreshold = 12;

      rail.addEventListener('pointerdown', function (event) {
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        pointerDown = true;
        dragging = false;
        suppressClick = false;
        capturedPointerId = null;
        startX = event.clientX;
        startY = event.clientY;
        startScroll = rail.scrollLeft;
      });

      rail.addEventListener('pointermove', function (event) {
        if (!pointerDown) return;
        var deltaX = event.clientX - startX;
        var deltaY = event.clientY - startY;

        if (!dragging) {
          if (Math.abs(deltaX) < dragThreshold || Math.abs(deltaX) <= Math.abs(deltaY)) return;
          dragging = true;
          suppressClick = true;
          capturedPointerId = event.pointerId;
          if (rail.setPointerCapture) {
            try { rail.setPointerCapture(event.pointerId); } catch (error) {}
          }
          rail.classList.add('is-dragging');
        }

        event.preventDefault();
        rail.scrollLeft = startScroll - deltaX;
      }, { passive: false });

      function finishDrag() {
        if (!pointerDown) return;
        pointerDown = false;
        rail.classList.remove('is-dragging');
        if (capturedPointerId !== null && rail.releasePointerCapture) {
          try { rail.releasePointerCapture(capturedPointerId); } catch (error) {}
        }
        capturedPointerId = null;
        if (dragging) {
          window.setTimeout(function () {
            dragging = false;
            suppressClick = false;
          }, 120);
        } else {
          suppressClick = false;
        }
      }

      rail.addEventListener('pointerup', finishDrag);
      rail.addEventListener('pointercancel', finishDrag);

      rail.addEventListener('click', function (event) {
        var link = event.target.closest('[data-preet-palate-link]');
        if (!link || !rail.contains(link)) return;
        if (suppressClick) {
          event.preventDefault();
          event.stopPropagation();
          return;
        }
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

        var targetUrl = link.getAttribute('data-preet-filter-url') || link.href;
        var parsedTarget = new URL(targetUrl, window.location.origin);
        if (parsedTarget.origin !== window.location.origin || parsedTarget.pathname.indexOf('/collections/') !== 0) return;

        event.preventDefault();
        fetchCollectionResults(parsedTarget.toString(), rail, link).catch(function () {});
      });

      rail.addEventListener('dragstart', function (event) {
        if (event.target.closest('a')) event.preventDefault();
      });

      var filterRoot = rail.closest('[data-preet-filter-root]');
      if (filterRoot && !filterRoot.hasAttribute('data-preet-history-ready')) {
        filterRoot.setAttribute('data-preet-history-ready', 'true');
        var initialTarget = targetFromLocation(filterRoot);
        var currentBase = filterRoot.getAttribute('data-preet-base-url') || window.location.pathname;
        if (new URL(window.location.href).searchParams.has('palate') && initialTarget !== currentBase) {
          var initialLink = Array.prototype.find.call(rail.querySelectorAll('[data-preet-palate-link]'), function (link) {
            var linkUrl = new URL(link.getAttribute('data-preet-filter-url') || link.href, window.location.origin);
            return linkUrl.pathname + linkUrl.search === new URL(initialTarget, window.location.origin).pathname + new URL(initialTarget, window.location.origin).search;
          });
          fetchCollectionResults(initialTarget, rail, initialLink || null, { pushState: false, scroll: false }).catch(function () {});
        }
      }
    });
  }

  window.addEventListener('popstate', function (event) {
    var rail = document.querySelector('[data-preet-category-rail]');
    var filterRoot = rail && rail.closest('[data-preet-filter-root]');
    if (!rail || !filterRoot) return;
    var targetUrl = event.state && event.state.preetPalateUrl ? event.state.preetPalateUrl : targetFromLocation(filterRoot);
    var activeLink = Array.prototype.find.call(rail.querySelectorAll('[data-preet-palate-link]'), function (link) {
      var linkUrl = new URL(link.getAttribute('data-preet-filter-url') || link.href, window.location.origin);
      var target = new URL(targetUrl, window.location.origin);
      return linkUrl.pathname + linkUrl.search === target.pathname + target.search;
    });
    fetchCollectionResults(targetUrl, rail, activeLink || null, { pushState: false, scroll: false }).catch(function () {});
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
